import React from 'react';
import csCat from '../assets/img cs.png';
import robotCat from '../assets/img ro.png';
import itCat from '../assets/img ba.png';

const cardClassName = `
  relative z-10
  flex-1 flex flex-col items-start justify-center
  gap-4 sm:gap-8
  rounded-3xl
  border-2 border-[#E150A8]
  bg-[#170D27]/95
  px-4 sm:px-8 md:px-16
  py-8 sm:py-12 md:py-16
  max-w-full sm:max-w-xl md:max-w-2xl
  shadow-[0_20px_60px_rgba(0,0,0,0.35)]
`;

const paragraphClassName =
  'text-base sm:text-lg md:text-2xl leading-relaxed text-white/80';

const greenTagClassName = `
  rounded-full border-2 border-[#0F081B]
  bg-[#3DFF80] px-4 py-2 sm:px-5 sm:py-3
  font-bold text-[#0F081B]
`;

const pinkTagClassName = `
  rounded-full border-2 border-[#0F081B]
  bg-[#E150A8] px-4 py-2 sm:px-5 sm:py-3
  font-bold text-[#0F081B]
`;

const outlineTagClassName = `
  rounded-full border-2 border-white/70
  bg-transparent px-4 py-2 sm:px-5 sm:py-3
  font-bold text-white
`;

const imageClassName = `
  relative z-10
  w-full max-w-[320px] sm:max-w-[400px] md:max-w-full
  h-auto object-contain
  drop-shadow-2xl
  bg-transparent
  mx-auto
`;

export default function Program() {
  return (
    <section
      id="programs"
      className="
        relative flex w-full flex-col
        items-center overflow-hidden
        bg-[#0F081B]
        px-4 py-16
        font-['Montserrat'] text-white
        sm:py-20
        md:py-24
      "
    >
      {/* Заголовок */}
      <div className="relative z-10 flex flex-col items-center justify-center gap-4 px-4 sm:gap-8">
        <h2 className="text-3xl font-black uppercase sm:text-5xl md:text-7xl">
          Напрямки
        </h2>

        <p className="max-w-4xl text-center text-base leading-relaxed text-white/80 sm:text-xl md:text-2xl">
          <span className="font-black text-[#3DFF80]">
            APPS SUMMER CAMP 2026
          </span>{' '}
          пропонує школярам такі напрямки навчання:
        </p>
      </div>

      {/* Computer Science */}
      <div
        className="
          container relative z-10 mx-auto
          flex flex-col items-center justify-between
          gap-6 px-4 py-8
          sm:gap-10 sm:px-8 sm:py-12
          md:px-16 md:py-20
          lg:flex-row lg:gap-12
        "
      >
        <div className={cardClassName}>
          <h3 className="text-xl font-black sm:text-3xl md:text-5xl">
            Комп&apos;ютерні науки
          </h3>

          <p className={paragraphClassName}>
            Любиш комп'ютерні ігри й хочеш навчитися програмувати?
            APPS Summer Camp тобі з цим допоможе!
            <br />
            <br />
            У програмі: 8 лекцій з Python та практичні заняття, де ти вивчиш
            основи програмування та навчишся використовувати код для
            розв&apos;язання практичних задач.
            <br />
            <br />
            Git та GitHub, де ти познайомишся з інструментами,
            які використовують справжні команди розробників.
            <br />
            <br />
            А ще — командний проєкт, у якому під супроводом
            ментора ти створиш власну текстову пригодницьку гру: від ідеї та
            сюжету до готового проєкту й фінальної презентації.
            <br />
            <br />
            <b>Цей напрям про:</b>
          </p>

          <div className="flex flex-row flex-wrap gap-2 sm:gap-4">
            <div className={greenTagClassName}>
              <p>Основи Python</p>
            </div>

            <div className={pinkTagClassName}>
              <p>Командна робота</p>
            </div>

            <div className={outlineTagClassName}>
              <p>Створення власної гри</p>
            </div>

            <div className={greenTagClassName}>
              <p>Практичні завдання</p>
            </div>

            <div className={pinkTagClassName}>
              <p>Вирішення задач</p>
            </div>

            <div className={outlineTagClassName}>
              <p>Алгоритмічне мислення</p>
            </div>
          </div>
        </div>

        <div className="flex flex-1 flex-col items-center justify-center">
          <div className="relative">
            <div
              aria-hidden="true"
              className="
                absolute left-1/2 top-1/2
                h-[75%] w-[75%]
                -translate-x-1/2 -translate-y-1/2
                rounded-full bg-[#E150A8]/40
                blur-3xl
              "
            />

            <img
              src={csCat}
              alt="Кіт — комп'ютерні науки"
              className={imageClassName}
              style={{
                background: 'none',
                pointerEvents: 'none',
                userSelect: 'none',
              }}
              draggable={false}
            />
          </div>
        </div>
      </div>

      {/* Robotics */}
      <div
        className="
          container relative z-10 mx-auto
          flex flex-col items-center justify-between
          gap-6 px-4 py-8
          sm:gap-10 sm:px-8 sm:py-12
          md:px-16 md:py-20
          lg:flex-row lg:gap-12
        "
      >
        <div className="flex flex-1 flex-col items-center justify-center">
          <div className="relative">
            <div
              aria-hidden="true"
              className="
                absolute left-1/2 top-1/2
                h-[75%] w-[75%]
                -translate-x-1/2 -translate-y-1/2
                rounded-full bg-[#3DFF80]/35
                blur-3xl
              "
            />

            <img
              src={robotCat}
              alt="Кіт — робототехніка"
              className={imageClassName}
              style={{
                background: 'none',
                pointerEvents: 'none',
                userSelect: 'none',
              }}
              draggable={false}
            />
          </div>
        </div>

        <div className={cardClassName}>
          <h3 className="text-xl font-black sm:text-3xl md:text-5xl">
            Робототехніка
          </h3>

          <p className={paragraphClassName}>
            Хочеш навчити машинку-робота рухатись, реагувати та думати? З APPS
            Summer Camp — це можливо!
            <br />
            <br />
            У програмі — лекції та практичні, де ти познайомишся з основами
            електроніки, навчишся працювати з кнопками, світлодіодами, сенсорами
            відстані та іншими компонентами. А ще — робота з реальними
            машинками, де ти напишеш код, побудуєш власну логіку руху та
            керування.
            <br />
            <br />
            Наприкінці — 2-денний хакатон, де кожна команда зможе
            обрати одну із запропонованих тем, втілити її на справжній машинці
            та презентувати результат на фінальному представленні!
            <br />
            <br />
            <b>Цей напрям про:</b>
          </p>

          <div className="flex flex-row flex-wrap gap-2 sm:gap-4">
            <div className={greenTagClassName}>
              <p>Командну роботу</p>
            </div>

            <div className={pinkTagClassName}>
              <p>Eлектроніку та сенсори</p>
            </div>

            <div className={outlineTagClassName}>
              <p>Основи Arduino та інших мікроконтролерів</p>
            </div>

            <div className={greenTagClassName}>
              <p>Програмування роботів</p>
            </div>
          </div>
        </div>
      </div>

      {/* IT & Decisions.Analytics */}
      <div
        className="
          container relative z-10 mx-auto
          flex flex-col items-center justify-between
          gap-6 px-4 py-8
          sm:gap-10 sm:px-8 sm:py-12
          md:px-16 md:py-20
          lg:flex-row lg:gap-12
        "
      >
        <div className={cardClassName}>
          <h3 className="text-xl font-black sm:text-3xl md:text-5xl">
            ІТ та аналітика рішень
          </h3>

          <p className={paragraphClassName}>
            Хочеш створити власну бізнес-ідею,
            яка може змінити світ навколо тебе?
            З APPS Summer Camp все можливо!
            <br />
            <br />
            У програмі — 4 лекції з Python, де ти познайомишся з основами
            програмування та навчишся розв&apos;язувати задачі за допомогою
            коду.
            <br />
            <br />
            А ще — 3 лекції та 2 практичні з економіки, де ти дізнаєшся,
            як створюються успішні проєкти та приймаються важливі
            бізнес-рішення.
            <br />
            <br />
            Наприкінці — створиш власну бізнес-ідею та
            презентуєш її на фінальному конкурсі!
            <br />
            <br />
            <b>Цей напрям про:</b>
          </p>

          <div className="flex flex-row flex-wrap gap-2 sm:gap-4">
            <div className={greenTagClassName}>
              <p>Командну роботу</p>
            </div>

            <div className={pinkTagClassName}>
              <p>Основи Python</p>
            </div>

            <div className={outlineTagClassName}>
              <p>Економіку</p>
            </div>

            <div className={greenTagClassName}>
              <p>Бізнес-моделювання</p>
            </div>

            <div className={pinkTagClassName}>
              <p>Практичні кейси</p>
            </div>

            <div className={outlineTagClassName}>
              <p>З ідеї в стартап</p>
            </div>
          </div>
        </div>

        <div className="flex flex-1 flex-col items-center justify-center">
          <div className="relative">
            <div
              aria-hidden="true"
              className="
                absolute left-1/2 top-1/2
                h-[75%] w-[75%]
                -translate-x-1/2 -translate-y-1/2
                rounded-full bg-[#6C4CCB]/40
                blur-3xl
              "
            />

            <img
              src={itCat}
              alt="Кіт — IT та аналітика"
              className={imageClassName}
              style={{
                background: 'none',
                pointerEvents: 'none',
                userSelect: 'none',
              }}
              draggable={false}
            />
          </div>
        </div>
      </div>
    </section>
  );
}
